export default __webpack_public_path__ + "static/media/instagram 1.6604a925.svg";